import { MutableRefObject, useEffect } from 'react'

export const useScrollToItem = (ref: MutableRefObject<HTMLElement | null>, id?: string) => {
  useEffect(() => {
    if (id && ref.current) {
      const element = ref.current.querySelector<HTMLElement>(`#${id}`)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }, [id, ref])
}
